// src/services/passwordResetService.js
import apiClient from '../core/apiClient';
import { API_CONFIG } from '../config/config';

export const passwordResetService = {
  requestReset: async (email, redirectUrl) => {
    const payload = { email, redirect_url: redirectUrl };
    const res = await apiClient.post(API_CONFIG.ENDPOINTS.AUTH.RESET_PASSWORD, payload, {
      headers: { skipAuthInterceptor: true },
    });
    return res.data; // { sent: boolean, reason?: 'google_only'|'no_account'|'bad_redirect' }
  },
};

